/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { DOCUMENT } from '@angular/common';
import { inject, Provider } from '@angular/core';
import { CssVariablesService } from '@common/modules/themes-switcher';
import { CSS_VARS_HOST_TOKEN } from '../tokens/css-vars-host.token';
import { DEFAULT_THEME_TOKEN } from '../tokens/default-theme.token';
import { THEME_TOKEN } from '../tokens/theme.token';
import { TestThemeSwitcherService } from './test-theme-switcher.service';

export const provideThemeSwitcherTesting = (): Provider[] => [
  TestThemeSwitcherService,
  CssVariablesService,
  {
    provide: DEFAULT_THEME_TOKEN,
    useValue: 'DEFAULT_THEME_TOKEN',
  },
  {
    provide: THEME_TOKEN,
    deps: [TestThemeSwitcherService],
    useFactory: (testService: TestThemeSwitcherService) => testService.theme$,
  },
  { provide: CSS_VARS_HOST_TOKEN, useFactory: () => inject(DOCUMENT).body },
];
